import { TrendingUp } from "lucide-react";

type BalanceHeaderProps = {
  title: string;
  amount: string;
  trend: string;
};

export function BalanceHeader({ title, amount, trend }: BalanceHeaderProps) {
  return (
    <div>
      <p className="text-sm font-medium text-muted">{title}</p>
      <h2 className="mt-1 text-3xl font-bold text-foreground">{amount}</h2>
      <div className="mt-1 flex items-center gap-1.5">
        <TrendingUp size={14} className="text-green" />
        <span className="text-sm font-medium text-green">{trend}</span>
      </div>
    </div>
  );
}
